import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[480px] md:h-[620px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20stadium%20atmosphere%20with%20dramatic%20stadium%20lighting%20and%20swirling%20golden%20and%20crimson%20energy%20particles%2C%20abstract%20artistic%20composition%20with%20motion%20blur%20effect%2C%20professional%20sports%20competition%20theme%2C%20dark%20moody%20background%20with%20warm%20amber%20spotlights%2C%20epic%20cinematic%20style%2C%20high%20contrast%20dramatic%20lighting%2C%20no%20text%20or%20logos&width=1600&height=900&seq=hero-crown-sports-2026&orientation=landscape"
          alt="皇冠体育 - 专业体育竞技平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
            <i className="ri-vip-crown-line text-3xl md:text-4xl text-accent-500"></i>
          </div>
          <h1 className="text-3xl md:text-5xl font-bold font-heading text-white whitespace-nowrap">
            皇冠体育
          </h1>
        </div>
        <p className="text-base md:text-xl text-white/85 max-w-2xl leading-relaxed mb-8">
          亚洲领先的专业体育竞技平台，覆盖足球、篮球、网球等数百项赛事<br className="hidden md:block" />
          实时赔率 · 安全存取款 · 24小时客服支持
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/football"
            className="px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看赛事
          </Link>
          <button className="px-8 py-3 bg-accent-500 text-foreground-950 rounded-full text-sm font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer">
            立即注册
          </button>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-3 gap-6 md:gap-12">
          {[
            { value: '15年+', label: '运营经验' },
            { value: '500万+', label: '注册用户' },
            { value: '10,000+', label: '月均赛事' },
          ].map((stat, index) => (
            <div key={index} className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-accent-500">{stat.value}</p>
              <p className="text-xs md:text-sm text-white/70 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}